import Grid from '@mui/material/Grid';
import moment from 'moment';
import strings from '../utility/strings.js';

const Footer = (props) => {
  const {styleprops} = props;
  return <Grid container style={styleprops}>
    <Grid item xs={12} className="mdl-mega-footer" component="footer">
      <div className="mdl-mega-footer__bottom-section">
        <ul className="mdl-mega-footer__link-list">
          <li><a href="https://dining.purdue.edu/">Dining & Culinary</a></li>
          <li><a href="https://eacct-purdue-sp.transactcampus.com/purdueeaccounts/AccountSummary.aspx">eAccounts Portal</a></li>
          <li><a href="https://dining.purdue.edu/AboutUs/map.html">Dining Map</a></li>
          <li><a href="https://dining.purdue.edu/ResidentialDining/mealplans/index.html">Meal Plans</a></li>
        </ul>
        <div className='copyright'>
          <a className="purdue-logo-link" href="https://purdue.edu"><img alt="Purdue University" src="https://www.purdue.edu/purdue/images/PU-V.svg" style={{height: 75}} /></a>
          <div className="copyright-statement">
            © {(moment()).format("YYYY")} Purdue University.<br />
            West Lafayette, IN 47906 (765) 494-4600 <br />
            An equal access/equal opportunity university. <br />
            {strings.hoursdisclaimerlong}<br />
            If you have trouble accessing this page because of a disability please <a href="mailto:studentlifemarketing@purdue.edu">contact us</a>.
          </div>
        </div>
      </div>
    </Grid>
  </Grid>
}

export default Footer;